import { PermissionClient } from '../../client/interfaces';
//import * as Logger from '../../common/tools/logger';
import { /*_PermissionStatus, PermissionData,*/ PermissionModel } from '../../interfaces';
import { PermissionClientCompat as PermissionClientCompatInterface, PermissionClientCompatOptions } from '../interfaces';
import Cookies from 'js-cookie';
import { CONFIG_VERSION } from '../../config';

//const CONSENT_PERMISSION_IDENTIFIER = 'tp_consent';
const CONSENT_LEVEL_COOKIE_IDENTIFIER = 'consentLevel';

/**
 * Permission Client Compatibility
 */
export class PermissionClientCompat implements PermissionClientCompatInterface {

  public version = CONFIG_VERSION;

  //private _moduleName = 'PermissionClientCompat';
  //private _permissionClient: PermissionClient = null;
  private _initialized = false;

  // private _options: PermissionClientCompatOptions = {
  //   cookieDomain: 'web.de',
  //   cookieExpiresInDays: 365,
  // };

   /**
   * @public
   * @function init
   * @description Function to initialize the Permission Client Compatibility Application
   * @param {PermissionClient} permissionClient Instance of a permission client
   * @param {PermissionClientCompatOptions} permissionClientCompatOptions Options for the compatibility application
   * @return {Promise<void>}
   */
  // eslint-disable-next-line
  public init(permissionClient?: PermissionClient, permissionClientCompatOptions?: PermissionClientCompatOptions): Promise<void> {
    // return a promise to maintain backwards compatibility
    // eslint-disable-next-line
    return new Promise((resolve, reject) => {

      // if (permissionClient == null) {
      //   Logger.error(this._moduleName, 'initialize', 'No Permission Client was given');
      //   reject();
      //   return;
      // }

      //this._permissionClient = permissionClient;
      // this._options = {
      //   ...this._options,
      //   ...permissionClientCompatOptions,
      // };

      this._initialized = true;
      resolve();
    });
  }

  /**
   * @public
   * @function computeModelByConsentLevel
   * @description Function to compute a the permission model by given consent level
   * @param {PermissionModel} permissionModel The given permission model
   * @return {PermissionModel}
   */
  public computeModelByConsentLevel(permissionModel: PermissionModel): PermissionModel {
    return permissionModel;

    // const consentLevel = this.getConsentLevel();
    // if (consentLevel != null) {
    //   const permissionStatus = this._getPermissionStatus(consentLevel);
    //   this._updatePermissionModel(permissionModel, permissionStatus);
    // }

    // // no consent found, remove consent permission from model
    // else {
    //   this._removeConsentPermission(permissionModel);
    // }
    // return permissionModel;
  }

  /**
   * @public
   * @function computeConsentLevelByModel
   * @description Function to extract the consent level by given permisison model
   * @param {PermissionModel} model The given permission model
   * @return {string}
   */
  // eslint-disable-next-line
  public computeConsentLevelByModel(model?: PermissionModel): string {
    return '0';
    //return this._extractConsentLevel(model);
  }

  /**
   * @public
   * @function updateModelByConsentLevel
   * @description Function to update the model by given consent level
   * @return {void}
   */
  public updateModelByConsentLevel(): void {

    if (!this._initialized) {
      throw new Error('PermissionClientCompat has to be initialized first')
    }
    return;
    
    // const currentModel: PermissionModel = this._permissionClient.options.getModel(),
    //   tpContentNotYetSet = currentModel.data.filter(item => item.usecase.toUpperCase() === CONSENT_PERMISSION_IDENTIFIER.toUpperCase()).length === 0;

    // if (tpContentNotYetSet) {
    //   currentModel.data.push({
    //     status: 'INVALID',
    //     usecase: CONSENT_PERMISSION_IDENTIFIER,
    //     timestamp: new Date().toISOString(),
    //   });
    // }

    // const permissionModel = this.computeModelByConsentLevel(currentModel);

    // // trigger the default handler in here to prevent overwrite of consentLevel by the client implementation
    // this._permissionClient.DEFAULT_HANDLER.onChange(permissionModel);
  }

  /**
   * @public
   * @function getConsentLevel
   * @description Function to get the consent level from a cookie
   * @return {void}
   */
  public getConsentLevel(): string {
    return Cookies.get(CONSENT_LEVEL_COOKIE_IDENTIFIER) || null;
  }

  /**
   * @public
   * @function setConsentLevel
   * @description Function to store the consent level into a cookie
   * @param {string} consentLevel
   * @return {void}
   */
  // eslint-disable-next-line
  public setConsentLevel(consentLevel?: string): void {
    if (!this._initialized) {
      throw new Error('PermissionClientCompat needs to be initialized before using this function');
    }
    return;

    // Cookies.set(CONSENT_LEVEL_COOKIE_IDENTIFIER, consentLevel, {
    //   domain: this._options.cookieDomain,
    //   expires: this._options.cookieExpiresInDays,
    //   sameSite: 'none',
    //   secure: window.location.protocol === 'https:' ? true : false,
    // });
  }

  /**
   * @private
   * @function _getPermissionStatus
   * @description Function to get the permission status by consent evel
   * @param {string} consentLevel
   * @return {_PermissionStatus}
   */
  // private _getPermissionStatus(consentLevel: string): _PermissionStatus {
  //   const consentLevelAsNumber = parseInt(consentLevel, 10);

  //   switch (consentLevelAsNumber) {
  //     case 1:
  //       return 'INVALID';
  //     case 2:
  //     case 3:
  //       return 'VALID';
  //     default:
  //       throw new Error(`Invalid consentLevel provided, has to be in the value range '1', '2' or '3'`);
  //   }
  // }

  /**
   * @private
   * @function _updatePermissionModel
   * @description Function to update the permission model
   * @param {PermissionModel} permissionModel Permission model which needs to be updated
   * @param {_PermissionStatus} tpConsentStatus Consent status to update
   * @return {PermissionModel}
   */
  // private _updatePermissionModel(permissionModel: PermissionModel, tpConsentStatus: _PermissionStatus): PermissionModel {

  //   const currentDate = new Date().toISOString();
  //   const tpConsentData = this._getPermissionDataByUsecase(permissionModel, CONSENT_PERMISSION_IDENTIFIER);

  //   if (tpConsentData != null) {
  //     // update timestamp if necessary
  //     tpConsentData.timestamp = tpConsentData.status === tpConsentStatus ? tpConsentData.timestamp : currentDate;

  //     // update status
  //     tpConsentData.status = tpConsentStatus;
  //   }

  //   // no permission data found for consent, add a new one
  //   else {
  //     permissionModel.data.push({
  //       usecase: CONSENT_PERMISSION_IDENTIFIER,
  //       timestamp: currentDate,
  //       status: tpConsentStatus
  //     })
  //   }

  //   return permissionModel;
  // }

  /**
   * @private
   * @function _removeConsentPermission
   * @description Removes consent permission data object from model
   * @param {PermissionModel} permissionModel The permission model from which to remove a consent permission data
   * @return {PermissionModel}
   */
  // private _removeConsentPermission(permissionModel: PermissionModel): PermissionModel {

  //   const tpConsentData = this._getPermissionDataByUsecase(permissionModel, CONSENT_PERMISSION_IDENTIFIER);

  //   if (tpConsentData != null) {
  //     const index = permissionModel.data.indexOf(tpConsentData);
  //     if (index > -1) {
  //       permissionModel.data.splice(index, 1);
  //     }
  //   }

  //   return permissionModel;
  // }

  /**
   * @private
   * @function _getPermissionDataByUsecase
   * @description Returns the reference to the permission data by given usecase
   * @param {PermissionModel} permissionModel
   * @param {string} usecase
   * @return {PermissionData}
   */
  // private _getPermissionDataByUsecase(permissionModel: PermissionModel, usecase: string): PermissionData {
  //   for (const pd of permissionModel.data || []) {
  //     if (pd.usecase.toUpperCase() === usecase.toUpperCase()) {
  //       return pd;
  //     }
  //   }

  //   return null;
  // }

  /**
   * @private
   * @function _extractConsentLevel
   * @description Function to extract the consent level from a permission model
   * @param {PermissionModel} permissionModel
   * @return {string}
   */
  // private _extractConsentLevel(permissionModel: PermissionModel): string {
  //   const consentPermissionData = permissionModel.data.filter(value => value.usecase.toUpperCase() === CONSENT_PERMISSION_IDENTIFIER.toUpperCase()).pop();

  //   if (consentPermissionData != null && consentPermissionData.status === 'VALID') {
  //     return '3';
  //   } else if (consentPermissionData != null && consentPermissionData.status === 'INVALID') {
  //     return '1';
  //   }

  //   return null;
  // }
}
